import React from "react";
import { LuMail, LuMessageCircleMore } from "react-icons/lu";
import OttoMarkIcon from "../../../../icons/js/OttoMarkIcon";
import { convertUtcToLocal } from "../../../../library/utils";
import { DATE_TIME_FORMATS } from "../../../../utils/dateTimes";
import { AUDIT_LOG_ICON } from "./constants";

/**
 * One audit-log row: a 16px glyph, then the event title over a
 * "{who or how} • {timestamp}" meta line.
 *
 * The glyphs are Lucide (already a dependency, and the family the design draws
 * from) plus the Otto brand mark; all three take their colour from the row so
 * state is legible at a glance without a text badge.
 */
const AuditLogItem = ({ item }) => {
  const renderIcon = () => {
    const iconProps = { size: 16, color: item.iconColor };
    if (item.icon === AUDIT_LOG_ICON.CHAT) return <LuMessageCircleMore {...iconProps} />;
    if (item.icon === AUDIT_LOG_ICON.MAIL) return <LuMail {...iconProps} />;
    return <OttoMarkIcon width={16} height={16} color={item.iconColor} />;
  };

  // Same conversion as an opportunity's "Created at" / "Updated at"
  // (opportunityLayer.js): stored UTC rendered in the viewer's local zone as
  // "Nov 19, 2025, 04:18 PM". Consistency across the lead profile matters more
  // than the dotted variant the Figma frame drew.
  const timestamp = convertUtcToLocal(item.timestamp, DATE_TIME_FORMATS.MMM_DD_YYYY_COMMA_hh_mm_A);

  return (
    <div className="flex items-start gap-2">
      {/* mt-[3px] centres the 16px glyph on the 22px first line: (22 - 16) / 2 */}
      <span className="mt-[3px] flex h-4 w-4 shrink-0 items-center justify-center">
        {renderIcon()}
      </span>
      {/* Two lines stacked with no gap — the 22px/20px line boxes do the spacing */}
      <div className="flex flex-col">
        <span className="text-sm leading-[22px] text-black">{item.title}</span>
        <span className="text-xs leading-5 text-[rgba(0,0,0,0.65)]">
          {`${item.metaPrefix} • ${timestamp}`}
        </span>
      </div>
    </div>
  );
};

export default AuditLogItem;
